// extracted by mini-css-extract-plugin
export var hasSubmenu = "NormalLinks-module--has-submenu--6f50d";
export var icon = "NormalLinks-module--icon--5f2a8";
export var iconWrapper = "NormalLinks-module--icon-wrapper--050c7";
export var isOpen = "NormalLinks-module--is-open--55c03";
export var normalLink = "NormalLinks-module--normal-link--6b867";
export var normalLinks = "NormalLinks-module--normal-links--4bd0f";
export var submenu = "NormalLinks-module--submenu--e211c";
export var submenuWrapper = "NormalLinks-module--submenu-wrapper--cd149";